import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParentEducationMoment } from '../../../models/parent-education-moment'
import { ResourcesCssService } from '../../resources/resources-css.service';

@Component({
  selector: 'app-pem',
  templateUrl: './pem.component.html',
  styleUrls: ['./pem.component.scss'],
})
export class PemComponent implements OnInit {

  @Input() pem: ParentEducationMoment

  isExpanded: boolean = false
  constructor(public resourcesCssService: ResourcesCssService) { }

  ngOnInit() {
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded
  }

  moreButtonClass() {
    return this.isExpanded ? 'mt-arrow-up' : 'mt-arrow-down'
  }

}
